import { Premiere } from '@filmweb/sanity-types';
import DataLoader from 'components/program/DataLoader';
import Shows from 'components/program/Shows';
import { toRem } from 'lib/client/fonts';
import UserSettings from 'lib/types/UserSettings';
import styled from 'styled-components';

//#region [Styles]
const SFilmProgram = styled.section`
	margin-top: 3.125rem;

	@media screen and (max-width: 640px) {
		padding: 10px;
		background: rgba(0, 0, 0, 0.7);
	}

`;

const SProgramTitle = styled.h1`
	text-align: center;
	text-transform: uppercase;
	font-size: ${toRem(31)};
	font-weight: var(--font_bold, bold);
	color: white;
	@media screen and (min-width: 641px) {
		color: currentColor;
	}
`;

const SDataLoader = styled(DataLoader)`
	p {
		color: white;
		@media screen and (min-width: 641px) {
			color: currentColor;
		}
	}
`;
//#endregion

//#region [Props]
type FilmProgramProps = {
	edi: string;
	nynorsk?: boolean;
	isKinoklubb: boolean;
	userSettings?: UserSettings;
	isPremiereInFuture?: boolean;
};
//#endregion

//#region [Component]
export default function FilmProgram({ edi, nynorsk = false, isKinoklubb, userSettings, isPremiereInFuture }: FilmProgramProps) {
	return <SFilmProgram>
		<SProgramTitle>{nynorsk ? "Framsyningar" : "Forestillinger"}</SProgramTitle>
		<SDataLoader edi={edi} loaderText={`Henter ${nynorsk ? "framsyninar" : "forestillinger"}`} skipDocuments userSettings={userSettings} isPremiereInFuture={isPremiereInFuture}>
			<Shows isKinoklubb={isKinoklubb} />
		</SDataLoader>
	</SFilmProgram>;
}
//#endregion
